import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import Button from "../../../../publicComponent/Button";
import ShippingAddressList from "./components/ShippingAddressList";
import ItemsTitle from "../my/orderDetail/components/ItemsTitle";
import GoodsCard from "./components/GoodsCard";
import BillCard from "./components/BillCard";
import ls from "../../../../utils/ls";
import ConfirmOrderContext, {ConfirmOrderController, useConfirmOrderContext} from "../../../../reducer/moduleReducer/confirmOrder";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import SubmitOrderButton from "../../../../publicComponent/submitOrderButton";
import {useEffect} from "react";
import Radio from "../../../../publicComponent/Radio";
import {useTranslation} from "react-i18next";

function PayType() {
  const { selectPayType } = ConfirmOrderController();
  const { state } = useConfirmOrderContext();
  const { t } = useTranslation();
  
  return (
    <>
      <div className="py-[30px] flex xl:pr-[15%] mdmax:hidden">
        {
          state.payTypeList.map((type, i) => (
            <div className="flex items-center cursor-pointer px-[12px] w-[22%] w-min-[100px]"
                 key={i}
                 onClick={() => selectPayType(type.type)}>
              <Radio checked={state.payType === type.type}/>
              <div className={`flex-1 rounded-[5px] w-max-[100px] border py-[20px] text-center mr-[5%] ${state.payType === type.type ? 'border-[#FFC75A] bg-[#FFFCF5] text-[#FFC75A]' : 'border-[#ddd] text-[#666]'}`}>
                {t(type.name)}
              </div>
            </div>
          ))
        }
      </div>
      
      <div className="md:hidden divide-y divide-[#eee] px-[15px]">
        {
          state.payTypeList.map((type, i) => (
            <div className="flex items-center"
                 key={i}
                 onClick={() => selectPayType(type.type)}>
              <Radio radioColor={'#444'} checked={state.payType === type.type}/>
              <div className={`flex-1 rounded-[5px] py-[18px] ${state.payType === type.type ? 'border-[#FFC75A]' : 'border-[#ddd] text-[#666]'}`}>
                {t(type.name)}
              </div>
            </div>
          ))
        }
      </div>
    
    </>
  );
}

function ExpressType() {
  const { selectExpressType } = ConfirmOrderController();
  const { state } = useConfirmOrderContext();
  const { t } = useTranslation();
  
  return (
    <div className="my-[18px] mdmax:text-center mdmax:mb-0 mdmax:mt-[7px]">
      <Button onClick={() => selectExpressType(2)}
              className={`text-[14px] py-[8px] mdmax:py-[3px] mdmax:text-[12px] border border-[#444] px-[34px]
      ${state.expressType === 2 ? 'text-white bg-[#2e2e2e]' : 'bg-white'}`}>{t('物流配送')}</Button>
      <Button onClick={() => selectExpressType(1)}
              className={`text-[14px] py-[8px] mdmax:py-[3px] mdmax:text-[12px] border border-[#444] px-[34px]
      ${state.expressType === 1 ? 'text-white bg-[#2e2e2e]' : 'bg-white'}`}
      >{t('到店自提')}</Button>
    </div>
  );
}

function ShopAddressList() {
  const { selectShopInfo } = ConfirmOrderController();
  const { state } = useConfirmOrderContext();
  const { shopList, shopInfo } = state;
  const { t } = useTranslation();
  
  return (
    shopList && shopList.length > 0
    && <>
      <div className="grid grid-cols-3 gap-4 pr-[50px] mb-[20px] mdmax:hidden">
        {
          shopList.map((shop, i) => {
            let isChecked = shop.shopId === shopInfo.shopId;
            return (
              <div key={i}
                   onClick={() => selectShopInfo(shop)}
                   className={'relative rounded-[10px] border cursor-pointer ' +
                   `${isChecked ? 'border-[#FFC75A] bg-[#FFFCF5]' : 'border-[#ddd] bg-white'} `}>
                <div className={'rounded-[8px] border pt-[25px] py-[20px] px-[20px] ' +
                `${isChecked ? 'border-[#FFC75A]' : 'border-[transparent]'}`}>
                  {
                    isChecked &&
                    <i style={{ lineHeight: '12px' }}
                       className="absolute right-[15px] top-[20px] iconfont icon-yes text-[20px] text-[#FFC75A]"></i>
                  }
                  <p className="mb-[10px] text-[16px] font-bold">{t('店铺名称')}：{shop.shopName}</p>
                  <div className="mb-[5px] flex min-h-[48px]">
                    <p>{t('店铺地址')}：{shop.areaname}{shop.address}</p>
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
      <div className="md:hidden">
        {
          shopList.map((shop, i) => {
            let isChecked = shop.shopId === shopInfo.shopId;
            return (
              <div key={i}
                   onClick={() => selectShopInfo(shop)}
                   className={'relative border-b cursor-pointer py-[8px] mx-[10px] ' +
                   `${isChecked ? 'border-[#FFC75A]' : 'border-[#ddd]'} `}>
                {
                  isChecked &&
                  <i style={{ lineHeight: '12px' }}
                     className="absolute right-[15px] top-[20px] iconfont icon-yes text-[20px] text-[#FFC75A]"></i>
                }
                <p className={`mb-[5px] text-[14px] font-bold ${isChecked ? 'text-[#FFC75A]' : ''}`}>{t('店铺名称')}：{shop.shopName}</p>
                <div className="mb-[5px] flex">
                  <p className={` ${isChecked ? 'text-[#FFC75A]' : ''}`}>{t('店铺地址')}：{shop.areaname}{shop.address}</p>
                </div>
              </div>
            );
          })
        }
      </div>
    </>
  );
}

function ConfirmOrderWrap() {
  const shopList = ls.getConfirmGoodsList();
  const { getAddressList } = ConfirmOrderController();
  const { state } = useConfirmOrderContext();
  const { t } = useTranslation();
  
  useEffect(() => {
    getAddressList();
  }, []);
  
  return (
    <Navigator.container className="container-center">
      <div className="pb-[32px]">
        <div className="md:mt-[25px]">
          <p className="font-bold text-[16px] px-[10px] pt-[24px] md:hidden">
            {t('配送信息')}
          </p>
          <ItemsTitle title="配送信息"/>
          <ExpressType/>
          {
            state.expressType === 2
              ? <ShippingAddressList isEdit/>
              : <ShopAddressList/>
          }
        </div>
        <ItemsTitle title="支付方式"/>
        <PayType/>
        {/*<WhiteSpec></WhiteSpec>*/}
        <ItemsTitle title="商品信息"></ItemsTitle>
        {
          shopList.map((shop, i) => (
            <div className="p-[15px]" key={i}>
              {/*<ShopInfoBar className="mb-[10px]" shopDetail={shop}/>*/}
              <h1 className="font-bold text-[15px]">{shop.shopName}</h1>
              <div className="">
                {
                  shop.goodsList.map((goods, i) => (
                    <GoodsCard key={i} data={goods}/>
                  ))
                }
              </div>
            </div>
          ))
        }
        <div className="flex">
          <p className="pt-[8px] flex-none font-bold pl-[15px]">{t('备注')}：</p>
          <textarea placeholder={t('请填写备注信息')}
                    className="border-none w-[100%] py-[8px] px-[15px] mdmax:bg-[transparent]"
                    style={{ resize: 'none' }}></textarea>
        </div>
        <BillCard isEdit shopList={shopList}/>
        <div className="text-right relative mt-[15px] md:hidden">
          <SubmitOrderButton
            className="rounded-l-full text-white bg-[#ECBC40] font-bold text-[14px] text-[#333]"/>
          <i className="iconfont icon-right absolute right-[15px] top-[6px]"/>
        </div>
      </div>
      {/*<FixedBar className="text-center bg-[#444]">*/}
      {/*  <SubmitOrderButton className="rounded-full"/>*/}
      {/*</FixedBar>*/}
    </Navigator.container>
  );
}

export default function ConfirmOrder() {
  return (
    <>
      <HeaderMall9/>
      <Navigator title="确认订单" goback noBorder/>
      <ConfirmOrderContext>
        <ConfirmOrderWrap/>
      </ConfirmOrderContext>
      <FooterMall9 noTabs/>
    </>
  );
}
